<template>
  <div class="report_builder">
    <v-container>
      <h2 class="mb-2">
        {{ $store.state.customerName }} メインメニュー作成画面
      </h2>
      <p>左の部品からドラッグして作成してください。</p>
      <v-col align="right"><v-btn @click.once="back">戻る</v-btn></v-col>
      <v-row>
        <v-col cols="12" sm="3">
          <h3 class="mb-2">Form Parts</h3>
          <draggable
            v-model="sampleForms"
            :group="{ name: 'forms', pull: 'clone', put: false }"
            :sort="false"
            :clone="cloneForm"
          >
            <v-card v-for="(form, i) in sampleForms" :key="i" class="mb-4">
              <v-card-title>{{ form.name }}</v-card-title>
              <v-card-text>{{ form.text }}</v-card-text>
            </v-card>
          </draggable>
        </v-col>
        <v-col cols="12" sm="9">
          <v-card outlined class="pa-6">
            <h3 class="mb-2">Form Area 1</h3>
            <draggable
              class="droparea"
              v-model="productForms.area"
              :group="{ name: 'forms', pull: true }"
              :options="{ animation: 100 }"
            >
              <!-- v-forでv-btnとv-iconを連続表示  -->
              <div
                class="d-flex align-center tmp"
                v-for="(form, i) in productForms.area"
                :key="i"
              >
                <v-btn @click="modalOpen(i)" block outlined
                  >{{ form.title }}:{{ form.icon }}</v-btn
                >
                <v-icon @click="removeForm(form, i)" color="grey"
                  >fas fa-times</v-icon
                >
                <!-------------------------------------------------->
                <v-dialog v-if="form.dialog" v-model="form.dialog">
                  <side-menu-form
                    v-on:clickSubmit="modalClose"
                    :type="6"
                    :position="i"
                    :icon="productForms.tmp.icon"
                    :title="productForms.tmp.title"
                    :items="productForms.tmp.items"
                  ></side-menu-form>
                </v-dialog>
              </div>
            </draggable>
            <!------------------------------------->
          </v-card>
          <v-row justify="center" class="mt-4">
            <v-btn @click="saveForm()" color="primary">SAVE</v-btn>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import SideMenuForm from "../../components/BuilderForm/SideMenuForm";
//
import { RepositoryFactory } from "../../api/RepositoryFactory";
const api = RepositoryFactory.get("api2");

export default {
  components: {
    draggable,
    SideMenuForm,
  },
  data() {
    return {
      sampleForms: [
        {
          type: 6,
          name: "メインメニュー",
          text: "メニュー項目",
          dialog: false,
          //
          icon: "fa-edit",
          title: "Report Builder",
          items: [
            { to: "/report_builder", text: "一覧" },
            { to: "/report_builder/create", text: "作成" },
          ],
        },
      ],
      productForms: {
        pageID: 0,
        area: [],
        delete_area: [],
      },
      reg_data: [],
    };
  },
  async mounted() {
    //初期処理
    await this.getInit();
  },
  methods: {
    async getInit() {
      //初期処理
      this.isLoading = true;
      //page IDとcustomer IDとform情報を送信
      let data = {};
      data.customerID = this.$store.state.customerID;
      data.pageID = Number(this.$route.params.page_id);
      this.productForms.pageID = this.$route.params.page_id;
      this.$store.state.customerID = Number(this.$route.params.id);
      const response = await api.GetForm(data);
      if (response.data[0][0].Type != 0) {
        console.log(response.data[0]);
        this.productForms.area = this.respose_convert(response.data[0]);
      }
      //読み込み終了
      this.isLoading = false;
    },
    cloneForm: function(obj) {
      //ここが登録される変数
      return {
        //共通
        type: obj.type,
        //
        icon: obj.icon,
        title: obj.title,
        items: obj.items,
        //
        dialog: obj.dialog,
      };
    },
    removeForm: function(form, i) {
      //console.log(form);
      form.delete_flag = true;
      this.productForms.delete_area.push(form);
      this.productForms.area.splice(i, 1);
    },
    async saveForm() {
      let data = {
        pageID: this.productForms.pageID,
        area: [this.productForms.area],
        delete_area: this.productForms.delete_area,
      };
      //data.area = this.productForms.area;
      //data.delete_area = this.productForms.delete_area;
      //data.pageID = this.productForms.pageID;
      try {
        data.pageID = await api.RegForm(data, "");
        alert("保存完了");
        this.back();
      } catch (err) {
        alert("送信失敗");
        console.log(err);
      }
    },
    modalOpen: function(i) {
      this.productForms.tmp = JSON.parse(
        JSON.stringify(this.productForms.area[i])
      );
      this.productForms.area[i].dialog = true;
    },
    modalClose(param) {
      let i = param.position;
      this.productForms.area[i].icon = param.icon;
      this.productForms.area[i].title = param.title;
      this.productForms.area[i].items = param.items;
      this.productForms.tmp = null;
      this.productForms.area[i].dialog = false;
    },

    respose_convert: function(data) {
      let area = [];
      data.forEach((value) => {
        let tmp = {};
        tmp.form_id = value.ID;
        tmp.type = value.Type;
        tmp.title = value.Label;
        tmp.icon = value.Init;
        if (value.Value == "") {
          tmp.items = JSON.parse('["a"]');
        } else {
          tmp.items = JSON.parse(value.Value);
        }
        tmp.dialog = false;
        area.push(tmp);
      });
      return area;
    },
    back() {
      history.back();
    },
  },
};
</script>

<style lang="stylus">
.droparea {
  background: #eee;
  min-height: 30em;
  padding: 1em;
}

/* ボタンの横に×ボタンwの表示するための調整 */
.tmp {
  width: 95%;
  padding: 0.2em;
  background-color: white;
}
</style>
